import React, { useRef, useEffect } from 'react';
import './WorksSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import MoreLink from "../../../components/MoreLink";
import Heading from "./../../../components/heading";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"

import Almqr from 'assets/images/works/almqr.webp'
import Khawalid from 'assets/images/works/khawalid.webp'
import SaudiNetLink from 'assets/images/works/saudinetlink.webp'
import SaudiaAqaria from 'assets/images/works/saudiaAqaria.webp'
import Mohtawa from 'assets/images/works/mohtawa.webp'
import Masheed from 'assets/images/works/masheed.webp'

import { gsap, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export const WorksItems = [
    {
        id: 1,
        img: Almqr,
        title: 'Almqr',
        href: 'https://almqr.com/'
    },
    {
        id: 2,
        img: Khawalid,
        title: 'Khawalid',
        href: 'https://xd.adobe.com/view/ac06b144-5172-4f6f-a6f8-e4475c899f11-f955/?fullscreen'
    },
    {
        id: 3,
        img: SaudiNetLink,
        title: 'SaudiNetLink',
        href: 'https://saudinetlink.sa/'
    },
    {
        id: 4,
        img: SaudiaAqaria,
        title: 'SaudiaAqaria',
        href: 'https://saudiare.sa/ar'
    },
    {
        id: 5,
        img: Mohtawa,
        title: 'Mohtawa',
        href: 'https://demo.rh.net.sa/em7/Mohtwize/'
    },
    {
        id: 6,
        img: Masheed,
        title: 'Masheed',
        href: 'https://xd.adobe.com/view/23a7f654-652f-42af-99a3-8111e470adfe-76f4/?fullscreen'
    }
]

export default function Works()
{

    // let image = useRef(null);
    // let container = useRef(null);
    // let imageReveal = CSSRulePlugin.getRule(".img-container:after");

    // let tl = new TimelineLite();

    // useEffect(() => {
    //     tl.to(container, 0, { css: { visibility: "visible" } });
    //     tl.to(imageReveal, 1.4, { width: "0%", ease: Power2.easeInOut });
    //     tl.from(image, 1.4, {
    //     scale: 1.6,
    //     ease: Power2.easeInOut,
    //     delay: -1.4
    //     });
    // })

    const revealRefs = useRef([]);
    revealRefs.current = [];


    useEffect(() =>
    {


        revealRefs.current.forEach((el, index) =>
        {

            gsap.fromTo(el, {
                scale: 0.7,
                opacity: 0,
            }, {
                duration: 1,
                scale: 1,
                opacity: 1,
                ease: Power2.easeInOut,
                scrollTrigger: {
                    id: `section-${index + 1}`,
                    trigger: el,
                    start: 'top center+=60',
                    toggleActions: 'play none none reverse'
                }
            });

        });

    }, []);

    const addToRefs = el =>
    {
        if (el && !revealRefs.current.includes(el))
        {
            revealRefs.current.push(el);
        }
    };

    console.log(revealRefs);
    return (
        <div id="works__section">
            <Container block={"true"}>
                <Heading title="أعمالنا"
                    subtitle="مشاريعنا و شركائنا في النجاح."
                />
                <ResponsiveMasonry
                    columnscountbreakpoints={{ 350: 2, 600: 3, 900: 3 }}
                >
                    <div className="container" >
                        <Masonry className="img__container">
                            {WorksItems.map(Work => (
                                <a key={Work.id} href={Work.href} target='_blank' rel='noopener' >
                                    <div className="img-container">
                                        <img ref={addToRefs}
                                            src={Work.img}
                                            alt={Work.title}
                                            loading="lazy"
                                        />
                                        <div className="caption">
                                            {Work.title}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </Masonry>
                    </div>
                </ResponsiveMasonry>

                <MoreLink href="https://works.rh.net.sa/" out linkname="المزيد" />
            </Container>
        </div>
    )
}